<div class="w-100 p-0 m-0 border-bottom">
    <dx-tabs [dataSource]="tabs"
        [selectedIndex]="$selectedTabIndex()"
        (selectedIndexChange)="$selectedTabIndex.set($event)"
        [showNavButtons]="true"
        orientation="horizontal"
        stylingMode="secondary"
        iconPosition="start"
        width="45%"
        [height]="50"
        class="ms-auto" />
</div>

<app-scroll-view style="height: calc(100% - 50px);">

    <dx-multi-view [selectedIndex]="$selectedTabIndex()" (selectedIndexChange)="$selectedTabIndex.set($event)">

        <dxi-multi-view-item>

            <dx-form *dxTemplate
                class="pb-3 mb-3"
                [items]="items"
                [(formData)]="formData"
                [readOnly]="$readOnly()"
                [validationGroup]="$validationGroupName()"
                [colCount]="1"
                [minColWidth]="250"
                [showValidationSummary]="true">

                <app-account-clients-list *dxTemplate="let data of 'clientsTemplate'"
                    [userId]="formData.Id"
                    [readOnly]="$readOnly()"
                    [validationGroupName]="$validationGroupName()"
                    [clientGroupId]="formData.XpressClientGroupId"
                    [(clients)]="formData.Clients"
                />
            </dx-form>

        </dxi-multi-view-item>

        <dxi-multi-view-item>

            <app-role-permissions-list *dxTemplate
                [permissions]="effectivePermissions"
                [userRoles]="userRoles"
                [readOnly]="true"
                />
        </dxi-multi-view-item>

    </dx-multi-view>

</app-scroll-view>

@if (loadIndicatorVisible) {
    <app-load-indicator />
}
